export default {
  name: 'OlocConfirmationScreen',
  components: {},
  props: {
    policy: {
      type: Object,
      required: true
    },
    continueButtonAction: Function,
    memberProfile: {
      // AnalyticsHub events will not be tracked if this is not provided
      type: Object,
      required: true
    },
    metadata: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      agreeToAllTerms: false
    };
  },
  computed: {
    readyToSubmit() {
      return this.agreeToAllTerms;
    }
  },
  watch: {
    agreeToAllTerms(newValue) {
      this.$analyticsHub.track('Single Page OLOC Started', {
        member_id: this.memberProfile.id,
        user_id: this.memberProfile.extra_user_id,
        plan_type: this.metadata.plan_type,
        plan_price: this.metadata.plan_cost,
        plan_frequency: this.metadata.billing_cycle,
        source: this.metadata.source
      });
    }
  },
  mounted() {
    this.$analyticsHub.track('Single Page OLOC Viewed', {
      member_id: this.memberProfile.id,
      user_id: this.memberProfile.extra_user_id,
      plan_type: this.metadata.plan_type,
      plan_price: this.metadata.plan_cost,
      plan_frequency: this.metadata.billing_cycle,
      source: this.metadata.source
    });
  },
  methods: {
    policyS3Redirect() {
      this.$analyticsHub.track('[Single Page OLOC][Web] Opened policy s3 url as tab', {
        member_id: this.memberProfile.id,
        user_id: this.memberProfile.extra_user_id,
        plan_type: this.metadata.plan_type,
        plan_price: this.metadata.plan_cost,
        plan_frequency: this.metadata.billing_cycle,
        source: this.metadata.source
      });
    }
  }
};